import classNames from "classnames";
import "./param-list.less"

interface Iprops {
    /**
     * 数据列表
     */
    listData: any[]
    /**
     * map出来的条目，自定义的ReactElement
     * @param dataItem 
     * @returns 
     */
    itemContainer: (dataItem: any) => React.ReactElement
    /**
     * 最外层className
     */
    wrapClassName?: string;
    /**
     * 最外层样式
     */
    style?: React.CSSProperties;
    /**
     * map出来的item的key在listData里面item的属性名
     */
    keyCode: string

}

export default function ParamListComponent(props: Iprops) {

    const { listData, wrapClassName, style, keyCode, itemContainer } = props

    return (
        <div className={classNames({
            'param-list-component-main': true
        }, wrapClassName)} style={style}>
            {listData?.map(item => (
                <div key={item[keyCode]} className="param-list-item">
                    {itemContainer(item)}
                </div>
            ))}
        </div>
    )
}